import { memo, useEffect, useMemo } from 'react';
// rtl
import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';
// emotion
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';

// ----------------------------------------------------------------------

type Props = {
  themeDirection: 'rtl' | 'ltr';
  children: React.ReactNode;
};

function RTL({ children, themeDirection }: Props) {
  // Dynamically update the `dir` attribute of the document
  useEffect(() => {
    document.dir = themeDirection;
  }, [themeDirection]);

  // Memoize cache instance to avoid re-creation on every render
  const cache = useMemo(
    () =>
      createCache({
        key: themeDirection === 'rtl' ? 'rtl' : 'ltr',
        prepend: true,
        // @ts-ignore
        stylisPlugins: themeDirection === 'rtl' ? [prefixer, rtlPlugin] : [],
      }),
    [themeDirection]
  );

  return <CacheProvider value={cache}>{children}</CacheProvider>;
}

export default memo(RTL);

// ----------------------------------------------------------------------

export function direction(themeDirection: 'rtl' | 'ltr') {
  return { direction: themeDirection };
}
